
export class GridConfig {

  constructor() {
  }

  // Public methods declarations
  methods: {
    refresh?: () => void;
  } = {};

}